export default "__VITE_ASSET__DKbK$qK7__"